import { useMemo } from 'react'
import Image from 'next/image'
import { Tile, TileCaption, TileOverlay } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useGrowthQuizCategoryMediaById } from 'libs/client/api/growth'
import { useTopCategoryId } from 'pages/find-my-classes/components/Quiz/steps/FullAccess/components/useTopCategoryId'
import { PersonalizedImageSkeleton } from './PersonalizedImageSkeleton'
import styles from './PersonalizedImage.module.scss'

export const PersonalizedImage = () => {
  const { t } = useTranslation('@mc/next')

  const topCategoryId = useTopCategoryId()
  const { category, parentCategoryWithMedia, getCategoryPrimaryMedia } =
    useGrowthQuizCategoryMediaById(topCategoryId)

  // If top category has no personalized image, use parent category
  const categoryMedia = category ? getCategoryPrimaryMedia(category) : null

  const displayCategory = categoryMedia ? category : parentCategoryWithMedia
  const displayMedia =
    categoryMedia || getCategoryPrimaryMedia(parentCategoryWithMedia)

  const displayInstructors = useMemo(
    () =>
      displayMedia?.instructors?.filter((instructor) => instructor.primary2x3),
    [displayMedia?.instructors],
  )

  if (!displayCategory || !displayMedia || !displayInstructors) {
    return <PersonalizedImageSkeleton />
  }

  return (
    <div className='d-flex justify-content-center flex-column align-items-center'>
      <Tile
        className={`${styles.tile} mc-w-100 mc-corners--md mc-overflow--hidden`}
      >
        <div className='d-flex mc-w-100 mc-h-100'>
          {displayInstructors.map(({ primary2x3 }, index) => (
            <div key={index} className='flex-1 position-relative'>
              <Image
                src={primary2x3!}
                alt=''
                fill
                style={{ objectFit: 'cover' }}
              />
            </div>
          ))}
        </div>
        <TileOverlay type='gradient-bottom' color='0,0,0' />
        <TileCaption padding={3}>
          <h2 className='mc-text--bold mc-my-1 mc-my-md-2'>
            {displayCategory.name}
          </h2>
          <p className='mc-text--bold mc-text-color--tint'>
            {t('findMyClasses.fullAccess.instructors', {
              instructors: displayInstructors?.map((i) => i.name).join(', '),
            })}
          </p>
        </TileCaption>
      </Tile>
      <div className='d-flex align-items-center justify-content-center mc-mt-7 mc-pt-2'>
        <p className='mc-text--center mc-text-color--tint'>
          {t('findMyClasses.fullAccess.subtitle')}
        </p>
      </div>
    </div>
  )
}
